<template>
    <v-row>
        <v-col cols="12">
            <div class="title-label">
                {{ $t(titleKey) }}
            </div>
            <div class="label">
                {{ $t(subtitleKey) }}
            </div>
        </v-col>
        <v-col cols="12">
            <kimsa-select
                :items="objectives"
                :values="objectivesArray"
                @change="objectivesArray = $event"
                multiple chip bordered item-text="label"
                ref="obj"
            />
        </v-col>
    </v-row>
</template>

<script>

import KimsaSelect from "@/components/common/inputs/KimsaSelect";
import { mapActions, mapState } from 'vuex'

export default {
    name: "ChooseObjectives",
    components: {
        KimsaSelect,
    },
    props: {
        titleKey: {
            type: String,
            required: true
        },
        subtitleKey: {
            type: String,
            required: true
        },
        stepperMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            objectivesArray: [],
        }
    },
    computed: {
        ...mapState(['config']),
        objectives(vm = this) {
            if (!vm.config) return []
            return vm.config.objectives.map(objective => ({ name: objective, value: objective, label: vm.objectiveLabel(objective) }))
        }
    },
    async mounted() {
        const vm = this
        if (!vm.config) await vm.bindConfig()
        vm.loadObjectives()
    },
    methods: {
        ...mapActions(['bindConfig']),
        loadObjectives() {
            const vm = this
            vm.objectivesArray = vm.account?.objectives || []
        }
    },
    watch: {
        account() {
            if (!this.stepperMode) this.loadObjectives()
        },
        objectivesArray(val) {
            this.$emit('change', val)
        },
    },
}
</script>

<style scoped>

.title-label {
    font-size: 26px;
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1.15;
    padding-bottom: 16px;
    color: var(--v-txtPrimary-base);
}

.label {
    font-size: 15px;
    color: var(--v-txtMuted-base);
    margin-top: 8px;
    line-height: 20px;
}

</style>
